export const formioBuilderComponentEditDisplay = [
    {
        type: 'textfield',
        input: false,
        label: 'Submission key',
        key: 'key',
        defaultValue: 'container',
        weight: 0,
    },
    {
        weight: 1,
        type: 'checkbox',
        label: 'Disabled',
        tooltip: 'Disable the component in form.',
        key: 'disabled',
        input: true,
    },
    {
        key: 'placeholder',
        ignore: true,
    },
    {
        key: 'labelPosition',
        ignore: true,
    },
    {
        key: 'tooltip',
        ignore: true,
    },
    {
        key: 'tabindex',
        ignore: true,
    },
    {
        key: 'autofocus',
        ignore: true,
    },
    {
        key: 'hideLabel',
        ignore: true,
    },
    {
        key: 'tableView',
        ignore: true,
    },
    {
        key: 'autofocus',
        ignore: true,
    },
    {
        key: 'label',
        ignore: true,
    },
    {
        key: 'customClass',
        ignore: true,
    },
    {
        key: 'hidden',
        ignore: true,
    },
    {
        key: 'modalEdit',
        ignore: true,
    },
];
